import { render, staticRenderFns } from "./editExchangeRate.vue?vue&type=template&id=bbce6d64&scoped=true&"
import script from "./editExchangeRate.vue?vue&type=script&lang=ts&"
export * from "./editExchangeRate.vue?vue&type=script&lang=ts&"
import style0 from "./editExchangeRate.vue?vue&type=style&index=0&id=bbce6d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce6d64",
  null
  
)

export default component.exports